import { User } from "./User";

export class DetailedUser extends User {
    isEmailConfirmed : boolean = false;
    createdAt : Date | null = null;
    createdBy : User | null = null;
    updatedAt : Date | null = null;
    updatedBy : User | null = null;
    stripeCustomerId : string = "";
    accessFailedCount : number | null = null;
    isForceChangePassword : boolean = false;
    lockoutEnabled : boolean = false;
    lockoutEnd : Date | null = null;
    promoCode : string = "";
    referralCode: string = "";
    referredBy: string = "";
    isShowingFirstTimeTutorial: boolean = false;
    newPassword?: string;

    constructor(init?: Partial<DetailedUser>) {
        super(init);
        if (!init) {
            return;
        }

        Object.assign(this, init);
    }
}
